export default {
  components: {
    styleOverrides: {
      root: ({ ownerState, theme }: { ownerState: any; theme: any }) => ({
        '&.Mui-checked': {
          ...(ownerState.color === 'secondary' && {
            color: theme.palette.grayBackground.A100
          })
        },
        '&.Mui-disabled': {
          color: theme.palette.grayBackground.A40
        },
        '&.error': {
          color: theme.palette.error.main
        },
        '&.error + .MuiFormControlLabel-label': {
          color: theme.palette.error.main
        }
      })
    }
  }
};
